{
    "Authentication_LoginButton": "Entrar",
    "LoginForm_LoginTitle": "Entre na sua conta",
    "LoginForm_WelcomeBack": "Bem-vindo de volta! Insira seus dados.",
    "LoginForm_Email": "Nome de utilizador",
    "LoginForm_EmailRequired": "E-mail é obrigatório",
    "LoginForm_InvalidEmail": "O nome de utilizador deve ser um e-mail",
    "LoginForm_EmailPlaceholder": "Insira seu e-mail",
    "LoginForm_Password": "Palavra-passe",
    "LoginForm_PasswordRequired": "Palavra-passe é necessária",
    "LoginForm_PasswordPlaceholder": "••••••••",
    "LoginForm_RememberMe": "Lembre de mim",
    "LoginForm_ForgotPassword": "Esqueceu sua palavra-passe",
    "LoginForm_SignIn": "Entrar",
    "NAME": "Authentication",
    "LoginForm_Username": "Nome de utilizador",
    "LoginForm_UsernameRequired": "Nome de utilizador é obrigatório",
    "LoginForm_UsernamePlaceholder": "Digite seu nome de utilizador",
    "LoginForm_CME": "CME",
    "LoginForm_Or": "(Ou)",
    "LoginForm_Server": "Servidor",
    "LoginForm_ServerPlaceholder": "Selecione o servidor para iniciar sessão",
    "LoginForm_LoginLanding_UserOnMultipleServices": "Esse nome de utilizador existe em vários serviços. Forneça informações adicionais para identificá-lo.",
    "LoginForm_LoginLanding_UserNonAdmin_Error": "Ocorreu um problema ao aceder sua conta. Entre em contacto com seu administrador para corrigir o problema.",
    "LoginForm_LandingPage_NextButton": "Continuar",
    "Authentication_ChangeBrowserProfile": "Alterar perfil do browser",
    "LoginForm_LoginLanding_User_Not_Found_Error": "Não conseguimos encontrar o nome de utilizador que introduziu. Verifique e tente novamente."
}